// Task status colors come from two sources: Tailwind color names picked via
// the app's own palette (e.g. "gray-600", "bg-gray-200" - see EditStatus.js),
// and raw hex codes from backend-seeded default statuses (e.g. "#4B5563").
// Tailwind can't generate CSS for a class name built from a runtime value
// (`text-${hex}` never matches a real utility), so raw colors must be applied
// via inline style instead of a class.
const isRawColorValue = (value) => /^#|^rgb|^hsl/i.test(value || "");

export const resolveBgColor = (value, fallbackClass = "bg-gray-100") => {
  if (!value) return { className: fallbackClass, style: undefined };
  if (isRawColorValue(value)) {
    return { className: "", style: { backgroundColor: value } };
  }
  return {
    className: value.startsWith("bg-") ? value : `bg-${value}`,
    style: undefined,
  };
};

export const resolveTextColor = (value, fallbackClass = "text-gray-400") => {
  if (!value) return { className: fallbackClass, style: undefined };
  if (isRawColorValue(value)) {
    return { className: "", style: { color: value } };
  }
  return {
    className: value.startsWith("text-") ? value : `text-${value}`,
    style: undefined,
  };
};
